import { ADDITIONAL_ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/additionalElectricTrend";
import { ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/electricLines";
import { ENGINE_CHART_TYPE, ENGINE_POSITION } from "../../constants/trendGraph/enginesLine";
import { SEP_CHART_TYPE } from "../../constants/trendGraph/sepLines";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType";
import localizationKeys from "../../i18n/localizationKeys";

export const DASHBOARD_MODE = {
  DISPLAY: "display",
  EDIT: "edit",
  CREATE: "create",
  SETTINGS: "settings"
}

export const DASHBOARD_ITEM_TYPE = {
  VALUE: "value",
  CUSTOM: "customTrend",
  ENGINE: "engineTrend",
  ELECTRIC: "electricTrend",
  SEP: "sepTrend",
  ADDITIONAL_ELECTRIC: "additionalElectricTrend",
  LIVE: "liveTrend",
  LABEL: "label",
};

export const DASHBOARD_DRAWER_CONTENT_TYPE = {
  CHANNELS: "channels",
  TRENDS: "trends",
  LIVE_TRENDS: "liveTrends",
};

export const DASHBOARD_TREND_GRAPH_LIST = [
  DASHBOARD_ITEM_TYPE.CUSTOM,
  DASHBOARD_ITEM_TYPE.ENGINE,
  DASHBOARD_ITEM_TYPE.ELECTRIC,
  DASHBOARD_ITEM_TYPE.SEP,
  DASHBOARD_ITEM_TYPE.ADDITIONAL_ELECTRIC,
];

export const DASHBOARD_ENGINE_TREND_TYPE = (position) => {
  switch (position) {
    case ENGINE_POSITION.CENTER:
      return [
        {
          id: "engine_load_center",
          name: "Engine Load (Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_LOAD,
        },
        {
          id: "engine_deviation_center",
          name: "Cylinder Deviation (Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          trendType: GRAPH_TYPE.ENGINE,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_DEVIATION,
        },
        {
          id: "engine_water_center",
          name: "Engine Water(Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_WATER,
        },
        {
          id: "engine_exhaust_center",
          name: "Cylinder (Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_EXHAUST,
        },
        {
          id: "engine_temp_center",
          name: "Engine Temp (Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_TEMP,
        },
        {
          id: "engine_press_center",
          name: "Engine Press (Center)",
          enginePosition: ENGINE_POSITION.CENTER,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_PRESS,
        },
      ];
    case ENGINE_POSITION.PORT:
      return [
        {
          id: "engine_load_port",
          name: "Engine Load (Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_LOAD,
        },
        {
          id: "engine_deviation_port",
          name: "Cylinder Deviation (Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_DEVIATION,
        },
        {
          id: "engine_water_port",
          name: "Engine Water(Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_WATER,
        },
        {
          id: "engine_exhaust_port",
          name: "Cylinder (Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_EXHAUST,
        },
        {
          id: "engine_temp_port",
          name: "Engine Temp (Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_TEMP,
        },
        {
          id: "engine_press_port",
          name: "Engine Press (Port)",
          enginePosition: ENGINE_POSITION.PORT,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_PRESS,
        },
      ];
    case ENGINE_POSITION.STARBOARD:
      return [
        {
          id: "engine_load_starboard",
          name: "Engine Load (Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_LOAD,
        },
        {
          id: "engine_deviation_starboard",
          name: "Cylinder Deviation (Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_DEVIATION,
        },
        {
          id: "engine_water_starboard",
          name: "Engine Water(Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_WATER,
        },
        {
          id: "engine_exhaust_starboard",
          name: "Cylinder (Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_EXHAUST,
        },
        {
          id: "engine_temp_starboard",
          name: "Engine Temp (Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_TEMP,
        },
        {
          id: "engine_press_starboard",
          name: "Engine Press (Starboard)",
          enginePosition: ENGINE_POSITION.STARBOARD,
          graphType: GRAPH_TYPE.ENGINE,
          chartType: ENGINE_CHART_TYPE.ENGINE_PRESS,
        },
      ];
    default:
      return [];
  }
};

export const DASHBOARD_ELECTRIC_TREND_TYPE = [
  {
    id: "electric_power",
    name: "Electric Power",
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ELECTRIC_TREND_TYPE.ELECTRIC_POWER_TREND,
  },
];

export const DASHBOARD_SEP_TREND_TYPE = [
  {
    id: SEP_CHART_TYPE.LEGS,
    name: localizationKeys.LegTrend_lower,
    graphType: GRAPH_TYPE.SEP,
    chartType: SEP_CHART_TYPE.LEGS,
  },
  {
    id: SEP_CHART_TYPE.THRUSTER,
    name: localizationKeys.Thruster_lower,
    graphType: GRAPH_TYPE.SEP,
    chartType: SEP_CHART_TYPE.THRUSTER,
  },
  {
    id: SEP_CHART_TYPE.CRANE1,
    name: localizationKeys.Crane1_lower,
    graphType: GRAPH_TYPE.SEP,
    chartType: SEP_CHART_TYPE.CRANE1,
  },
  {
    id: SEP_CHART_TYPE.CRANE2,
    name: localizationKeys.Crane2_lower,
    graphType: GRAPH_TYPE.SEP,
    chartType: SEP_CHART_TYPE.CRANE2,
  },
  {
    id: SEP_CHART_TYPE.TRIM_AND_HEEL,
    name: localizationKeys.TrimAndHeel_lower,
    graphType: GRAPH_TYPE.SEP,
    chartType: SEP_CHART_TYPE.TRIM_AND_HEEL,
  },
];

export const DASHBOARD_ADDITIONAL_ELECTRIC_TREND_TYPE = [
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    name: localizationKeys.ElectricTrendGraph_upper,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
    name: localizationKeys.BusVoltCurrent,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
    name: localizationKeys.MainDGMachineryStatus,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
    name: localizationKeys.No1GECylTemp,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
    name: localizationKeys.No1GECylTemp,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
    name: localizationKeys.No1GECylTemp,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
    name: localizationKeys.No1GECylTemp,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
    name: localizationKeys.No1GECylTemp,
    graphType: GRAPH_TYPE.ELECTRIC,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
];
